export default class RelativeDiagnosis {
	constructor() {
		this.diagnosisName = null;
		this.dateDiagnosed = [];
	}
}
